import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import { EmpShiftsVm, ShiftListItem, ApiResponse } from '@/api/types'

export interface ShiftListResponse {
  data: ShiftListItem[]
  totalRecords?: number
  pageNumber?: number
  pageSize?: number
}

/**
 * Shift (ApiShift) service for HR Settings
 */
export class ShiftService {
  async getAll(
    branchId: number,
    pageNumber: number,
    pageSize: number
  ): Promise<ShiftListResponse> {
    const url = endpoints.apiShift.getAll(branchId, pageNumber, pageSize)
    const response = await apiClient.get<ApiResponse<ShiftListResponse> | ShiftListResponse | ShiftListItem[]>(url)
    const payload = response.data

    if (Array.isArray(payload)) {
      return { data: payload, totalRecords: payload.length, pageNumber, pageSize }
    }
    if (payload && typeof payload === 'object') {
      if ('data' in payload && Array.isArray((payload as any).data)) {
        const p = payload as ShiftListResponse
        return {
          data: p.data,
          totalRecords: p.totalRecords ?? p.data.length,
          pageNumber: p.pageNumber ?? pageNumber,
          pageSize: p.pageSize ?? pageSize,
        }
      }
      if ('success' in payload && 'data' in payload) {
        const data = (payload as ApiResponse<ShiftListResponse>).data
        return {
          data: Array.isArray(data) ? data : (data as any)?.data ?? [],
          totalRecords: (data as any)?.totalRecords,
          pageNumber: (data as any)?.pageNumber ?? pageNumber,
          pageSize: (data as any)?.pageSize ?? pageSize,
        }
      }
    }
    return { data: [], totalRecords: 0, pageNumber, pageSize }
  }

  async getById(id: number, branchId: number): Promise<EmpShiftsVm> {
    const url = endpoints.apiShift.getById(id, branchId)
    const response = await apiClient.get<ApiResponse<EmpShiftsVm> | EmpShiftsVm>(url)
    const payload = response.data
    if (payload && typeof payload === 'object' && 'data' in payload) {
      return (payload as ApiResponse<EmpShiftsVm>).data as EmpShiftsVm
    }
    return (payload ?? {}) as EmpShiftsVm
  }

  async create(shift: Record<string, unknown>): Promise<any> {
    const url = endpoints.apiShift.create
    console.log('🔵 [ShiftService.create] Payload:', JSON.stringify(shift, null, 2))
    const response = await apiClient.post(url, shift, {
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
    return response.data
  }

  async update(shift: Record<string, unknown>): Promise<any> {
    const url = endpoints.apiShift.update
    console.log('🔵 [ShiftService.update] Payload:', JSON.stringify(shift, null, 2))
    const response = await apiClient.put(url, shift, {
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
    return response.data
  }

  async delete(id: number): Promise<any> {
    const url = endpoints.apiShift.delete(id)
    const response = await apiClient.delete(url)
    return response.data
  }
}

export const shiftService = new ShiftService()
